import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../../services/general.service';
import { GroupService } from '../../../services/group.service';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss']
})
export class CompanyComponent implements OnInit {
  userId: any;
  userToken: any;
  textButton: any;
  loadBtn = false;
  type: any;
  company: any = {};
  listProfiles: any;
  editId: any;

  constructor(private toastr: ToastrService, public dialogRef: MatDialogRef<CompanyComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private gralService: GeneralService, private groupService: GroupService) {
    this.type = this.data.type;
    this.userId = this.data.userId;
    this.userToken = this.data.userToken;

    if(this.type === 'add'){
      this.textButton = 'ADDCOMPANY';
    }else{
      this.company = this.data.info;
      this.editId = this.data.id;
      this.textButton = 'EDITCOMPANY';
    }
  }

  ngOnInit() {
  }

  onCloseConfirm() {
    if(!this.company.RFC || !this.company.RazonSocial){
      this.toastr.error('Favor de llenar los campos obligatorios', 'Error al agregar empresa');
      return false;
    }

    this.company.RFC = this.company.RFC.toUpperCase();
    this.company.Nombre = this.company.RazonSocial.toUpperCase();

    this.loadBtn = true;
    if(this.type == 'add'){
      this.groupService.newCompany(this.company, this.userToken).then((data) => {
        this.loadBtn = false;
        if(data['esValido']){
          this.dialogRef.close({ data: data['entidad'] });
        }else{
          this.toastr.error(data['mensajeUsuario'], 'Error al agregar empresa');
          return;
        }
      }, (err) => {
        this.loadBtn = false;
        console.log(err);
        this.toastr.error(err['error'].msg, 'Error al agregar empresa');
        if(err.status == 401){
          this.gralService.actDeacUser(false);
        }
      });
    }

    if(this.type == 'edit'){
      this.groupService.updateCompany(this.editId, this.userId, this.userToken).then((data) => {
        this.loadBtn = false;
        if(data['esValido']){
          this.dialogRef.close({ data: data['entidad'] });
        }else{
          this.toastr.error(data['mensajeUsuario'], 'Error al editar empresa');
          return;
        }
      }, (err) => {
        this.loadBtn = false;
        console.log(err);
        this.toastr.error(err['error'].msg, 'Error al editar empresa');
        if(err.status == 401){
          this.gralService.actDeacUser(false);
        }
      });
    }
  }

  onCloseCancel() {
    this.dialogRef.close();
  }

}
